/* =========================================================
   MIMANE PARIS — Shopify Section Scripts
   Namespaced under window.mimane to avoid theme conflicts
   ========================================================= */

window.mimane = window.mimane || {};

/* ---------- FAQ accordion ---------- */
mimane.initFaq = function (root) {
  root = root || document;
  var items = root.querySelectorAll('.mimane-qa');
  items.forEach(function (item) {
    var trigger = item.querySelector('.mimane-q');
    if (!trigger || trigger.dataset.mimaneBound) return;
    trigger.dataset.mimaneBound = 'true';
    trigger.addEventListener('click', function () {
      item.classList.toggle('mimane-open');
      var expanded = item.classList.contains('mimane-open');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });
};

/* ---------- Email capture form (placeholder submit handling) ---------- */
mimane.initCaptureForm = function (root) {
  root = root || document;
  var forms = root.querySelectorAll('.mimane-cform[data-mimane-form]');
  forms.forEach(function (form) {
    if (form.dataset.mimaneBound) return;
    form.dataset.mimaneBound = 'true';
    form.addEventListener('submit', function (e) {
      // Shopify customer/newsletter forms handle submission natively;
      // this is a hook for custom validation or analytics if needed.
    });
  });
};

/* ---------- Init on load + Shopify section reloads ---------- */
document.addEventListener('DOMContentLoaded', function () {
  mimane.initFaq();
  mimane.initCaptureForm();
});

document.addEventListener('shopify:section:load', function (e) {
  mimane.initFaq(e.target);
  mimane.initCaptureForm(e.target);
});